import type { ReactNode } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';

import { getOfferHrefWithVersion } from 'utils';

const OfferLink = () => {
  const { locale } = useIntl();

  const renderLink = (chunks: ReactNode) => {
    const href = getOfferHrefWithVersion(locale);

    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className="text-base-blue-100/60 font-bold hover:underline"
      >
        {chunks}
      </a>
    );
  };

  return (
    <span className="block text-[10px] font-normal leading-3 text-black/60 text-center md:text-left">
      <FormattedMessage id="accept_offer" values={{ a: renderLink }} />
    </span>
  );
};

export { OfferLink };
